import { Controller } from '@hotwired/stimulus'

// Change a Turbo Frame src OR a links href via events
//
// For example:
//  Sortable stimulus controller dispatches a "sortable:sorted" event
//  which is caught by this controller and updates the URL of
//
//  <a href="https://myurl.com?columns=old,columns,list"
//     data-controller="change-element-url"
//     data-change-element-url-attribute="href"
//     data-change-element-url-param="columns"
//     data-action="sortable:sorted@window->change-element-url#updateUrlParam">
//
//  If you want to change the "?columns=" param in a URL you'd send this:
//
//   window.dispatchEvent(new CustomEvent('sortable:sorted', {
//     detail: {
//       columns: "new,columns,list",
//     },
//   }))
//
// Currently limited to changing a single param, not the full URL but can be
// extended to do that.

export default class extends Controller {
    static values = {
        attribute: { type: String, default: 'src' },
        param: { type: String, default: 'columns' },
    }

    updateUrlParam(event) {
        const paramValue = event.detail[this.paramValue]

        // Get the current URL from the specified attribute
        const { element } = this
        const currentUrl = element.getAttribute(this.attributeValue)

        // Parse the URL and update the specified parameter
        const url = new URL(currentUrl, window.location.origin)

        // Handle arrays (join with comma) or single values
        if (Array.isArray(paramValue)) {
            url.searchParams.set(this.paramValue, paramValue.join(','))
        } else {
            url.searchParams.set(this.paramValue, paramValue)
        }

        element.setAttribute(this.attributeValue, url.toString())
    }
}
